<template lang="html">
    <div>
        <UiModal
            :active="$store.state.payments.modal.active"
            @close="close"
            title="Finalizare tranzacție"
            subtitle="Credit / Debit Card"
            :buttons="buttons"
            :credits="credits"
            @retry="retryPayment"
            @submit="submitPayment = true"
        >

            <template slot="body">
                <StripePaymentForm
                    @complete="buttons[0].disabled = !$event"
                    :submitPayment="submitPayment"
                    v-if="$store.state.payments.current.gateway == 'stripe'"
                    @paymentFailed="paymentFailed"
                    :retry="retry"
                />
            </template>
        </UiModal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UiButton from '@/components/ui/Button'
import UiModal from '@/components/ui/Modal'
import StripePaymentForm from '@/components/forms/Payments/Stripe'

export default {
    components: {
        UiButton,
        UiModal,
        StripePaymentForm
    },
    data() {
        return {
            buttons: [
                {
                    event: "submit",
                    text: "Finalizare tranzacție",
                    disabled: true
                },
            ],
            credits: {
                icon: 'fas fa-lock',
                text: 'Plată securizată prin platforma',
                link: 'https://stripe.com/',
                linkTitle: 'Stripe'
            },
            submitPayment: false,
            retry: false
        };
    },
    computed: {
        ...mapGetters({
            current: 'payments/current',
            isLoading: 'payments/isLoading'
        })
    },
    watch: {
        isLoading(value) {
            if(value)
                this.buttons[0].text = 'Procesare plată..';
        }
    },
    methods: {
        ...mapActions({
            closeModal: 'payments/closeModal',
            cancelAppointment: 'appointments/cancelAppointment'
        }),
        close() {
            if (this.current.entity === 'booking') {
                this.cancelAppointment({
                    id: this.current.appointment.id,
                    isBooking: true
                });
            }
            
            if(this.submitPayment) location.reload(); //reload page for avoiding unexpected situations
            
            this.$store.state.payments.errorKey = null;
            this.closeModal();
        },
        paymentFailed() {    
            this.buttons = [
                {
                    event: "close",
                    text: "Renunță",
                    style: 'close',
                    disabled: false
                },
                {
                    event: "retry",
                    text: "Reîncearcă",
                    disabled: false
                }
            ];
        },
        retryPayment() {
            // this.$store.state.payments.retry = true;
            this.$store.state.payments.errorKey = null;
            this.submitPayment = !this.submitPayment;
            
            this.buttons = [
                {
                    event: "submit",
                    text: "Finalizare tranzacție",
                    disabled: true
                }
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
    .tds-iframe{
       position: absolute; 
       width: 100%;
       height: 100%;
       top: 0px;
       left: 0px;
    }
</style>
